import {
    MdAccountBalanceWallet,
    MdCheckCircle,
    MdPayments,
    MdReceiptLong,
} from 'react-icons/md'

/**
 * Última tela do assistente, exibida DEPOIS que tudo foi gravado.
 *
 * Fica aqui, e não numa notificação solta, porque é o único momento em que o dono
 * da conta já terminou o cadastro e ainda está com a atenção no assunto: sem conta
 * digital, cobrar pelo sistema não funciona, e descobrir isso na primeira cobrança
 * é tarde.
 */
export default function DigitalAccountStep() {
    const benefits = [
        {
            icon: <MdPayments className="text-2xl" />,
            title: 'Receber por PIX, cartão e boleto',
            description:
                'A cobrança do atendimento é gerada pelo sistema e cai direto na sua conta.',
        },
        {
            icon: <MdReceiptLong className="text-2xl" />,
            title: 'Repasse e conciliação automáticos',
            description:
                'O que é seu e o que é do parceiro sai calculado, com extrato de cada entrada.',
        },
    ]

    return (
        <div className="flex flex-col gap-6">
            <div className="flex items-start gap-3 rounded-lg border border-success/30 bg-success/5 p-4">
                <MdCheckCircle className="mt-0.5 shrink-0 text-2xl text-success" />
                <div>
                    <p className="font-medium text-base-content">
                        Sua conta está configurada
                    </p>
                    <p className="text-sm text-base-content/70">
                        Profissional, especialidades, catálogo e exames já estão prontos
                        para uso.
                    </p>
                </div>
            </div>

            <div className="flex flex-col items-center gap-3 text-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary/10">
                    <MdAccountBalanceWallet className="text-4xl text-secondary" />
                </div>
                <p className="text-base-content/70">
                    Agora chegou a hora de ativar sua conta digital para o gerenciamento
                    financeiro completo.
                </p>
            </div>

            <ul className="flex flex-col gap-3">
                {benefits.map(benefit => (
                    <li
                        key={benefit.title}
                        className="flex items-start gap-3 rounded-lg border border-base-300 p-4"
                    >
                        <span className="mt-0.5 shrink-0 text-secondary">
                            {benefit.icon}
                        </span>
                        <div className="min-w-0">
                            <p className="font-medium text-base-content">
                                {benefit.title}
                            </p>
                            <p className="text-sm text-base-content/70 whitespace-normal">
                                {benefit.description}
                            </p>
                        </div>
                    </li>
                ))}
            </ul>

            <p className="text-sm text-base-content/60 whitespace-normal">
                A ativação pede alguns documentos e é analisada pelo banco parceiro. Você
                pode fazer isso depois, em Financeiro › Conta Digital — o resto do sistema
                funciona normalmente enquanto isso.
            </p>
        </div>
    )
}
